<template>
  <div class="tracks_container">
    <div class="track_list">
      <transition-group v-if="searchItems" class="track" name="tracks-list" tag="ul" appear>
        <li
          :style="{'transition-delay':`${(index)*0.3}s`}"
          v-for="(item,index) in searchItems"
          :key="index"
          class="track_name"
          :class="{'YTcurrentTrack':YTcurrentTrack ===item.id,'KKcurrentTrack':KKcurrentTrack ===item.id,
          'clickTrack':clickTrack ===item.id}"
          :data-text="item.name"
          @click="myTrack(item)"
        >
          {{item.name}}
          <div class="play_btn_container">
            <button class="playBtn playYoutube" @click="playYT(item)">
              <i class="fab fa-youtube track_YT_icon"></i>
            </button>
            <button class="playBtn playKKbox" @click="playKkbox(item)">
              <i class="fab fa-kickstarter track_KK_icon"></i>
            </button>
            <button v-if="code" class="playBtn playKKbox" @click="addToFavorite(item)">
              <i class="far fa-star favorite_icon"></i>
            </button>
          </div>
        </li>
      </transition-group>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      accessToken: "",
      clickTrack: ""
    };
  },
  computed: {
    code() {
      return this.$store.state.code;
    },
    searchItems() {
      return this.$store.state.searchItems;
    },
    YTcurrentTrack() {
      return this.$store.state.YTcurrentTrack;
    },
    KKcurrentTrack() {
      return this.$store.state.KKcurrentTrack;
    },
    YTcurrentTrack() {
      return this.$store.state.YTcurrentTrack;
    },
    iframeId() {
      return this.$store.state.iframeId;
    },
    creatItem() {
      let num = Math.floor(Math.random() * 4);
      let creatItem = this.searchItems[num];
      return creatItem;
    }
  },
  methods: {
    myTrack(item) {
      this.clickTrack = "";
      this.clickTrack = item.id;
    },
    playKkbox(item) {
      this.$store.dispatch("playKkbox", item);
    },
    playYT(item) {
      this.$store.dispatch("playYT", item);
    },
    getAccessToken() {
      const vm = this;
      if (!vm.code) {
        return false;
      } else {
        const api =
          "https://cors-anywhere.herokuapp.com/https://account.kkbox.com/oauth2/token";
        const config = {
          headers: {
            Accept: "application/x-www-form-urlencoded",
            "Content-Type": "application/x-www-form-urlencoded"
          }
        };
        const oauth = {
          grant_type: "authorization_code",
          code: this.code,
          client_id: "fb254aff20b31017a2e84e34ed896523",
          client_secret: "d2f7853d7a7e2afd98bc4751f1b3c81a"
        };
        this.$http.post(api, this.$qs.stringify(oauth), config).then(res => {
          vm.accessToken = res.data.access_token;
        });
      }
    },
    addToFavorite(item) {
      const vm = this;
      let trackid = item.id;
      const FaAutho = {
        headers: {
          Authorization: ` Bearer ${vm.accessToken}`,
          "Content-Type": "application/json"
        }
      };
      const faTrackId = { track_id: item.id };
      vm.$http
        .post(
          "https://cors-anywhere.herokuapp.com/https://api.kkbox.com/v1.1/me/favorite",
          faTrackId,
          FaAutho
        )
        .then(res => {
          alert(res.data.message);
        });
    }
  },
  mounted() {
    const vm = this;
    this.getAccessToken();
    window.setTimeout(function() {
      let once = vm.creatItem;
      vm.playKkbox(once);
    }, 3000);
  }
};
</script>

<style scope>
@import url("../assets/tracks_container_test.css");
@import url("../assets/tracks_container_RWD.css");
.tracks-list-enter-active,
.tracks-list-leave-active {
  transition: all 1s;
  /* opacity: 1; */
}
.tracks-list-enter, .tracks-list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-100%);
}
</style>